import React from "react";
import { Skeleton, Box, Typography } from "@mui/material";
import { AnalysisContainer, LoadingSection } from "./PerformanceStyles";

export const AnalysisSkeleton: React.FC = () => {
  return (
    <AnalysisContainer>
      <LoadingSection>
        <Box
          sx={{
            mb: 2,
            border: "1px solid",
            borderColor: "divider",
            borderRadius: 1,
          }}
        >
          <Box sx={{ p: 2, borderBottom: "1px solid", borderColor: "divider" }}>
            <Skeleton variant="text" width="35%" height={40} animation="wave" />
          </Box>
          <Box sx={{ p: 3 }}>
            <Skeleton
              variant="text"
              width="100%"
              height={24}
              animation="wave"
              sx={{ mb: 1.5 }}
            />
            <Skeleton
              variant="text"
              width="95%"
              height={24}
              animation="wave"
              sx={{ mb: 1.5 }}
            />
            <Skeleton
              variant="text"
              width="90%"
              height={24}
              animation="wave"
              sx={{ mb: 2 }}
            />
            <Skeleton
              variant="text"
              width="100%"
              height={24}
              animation="wave"
              sx={{ mb: 1.5 }}
            />
            <Skeleton variant="text" width="85%" height={24} animation="wave" />
          </Box>
        </Box>
        <Typography
          variant="h6"
          sx={{
            color: "text.secondary",
            mb: 2,
          }}
        >
          Fetching Analysis...
        </Typography>
        {[1, 2, 3].map((index) => (
          <Box
            key={index}
            sx={{
              mb: 2,
              border: "1px solid",
              borderColor: "divider",
              borderRadius: 1,
              p: 2,
            }}
          >
            <Skeleton
              variant="text"
              width={`${30 + index * 5}%`}
              height={40}
              animation="wave"
            />
          </Box>
        ))}
      </LoadingSection>
    </AnalysisContainer>
  );
};
